
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tools/vaccination",
      function () {
        return require("private-next-pages/tools/vaccination/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tools/vaccination"])
      });
    }
  